import React from 'react';
import T from 'prop-types';
import PlaybackControls from './components/playback-controls';
import AddMarkerButton from './components/add-marker-button';
import WaveformZoomControl from './components/waveform-zoom-control';
import AudioFileUpload from './components/audio-file-upload';

const ControlBar = ({
  audioProgress,
  waveformZoomLevel,
  isLoading,
  isPlaying,
  onPlay,
  onPause,
  onAddMarker,
  onWaveformZoom,
  onAudioFileUpload,
}) => (
  <div className="editor-controls">
    <div className="editor-controls editor-controls__fix">
      <PlaybackControls
        audioProgress={audioProgress}
        isPlaying={isPlaying}
        isLoading={isLoading}
        onPlay={onPlay}
        onPause={onPause}
      />
    </div>
    <div className="editor-controls editor-controls__fluid">
      <AddMarkerButton onClick={onAddMarker} />
      <div className="editor-controls__item-container">
        <div className="editor-controls__item-container--separator" />
      </div>
      <WaveformZoomControl zoomLevel={waveformZoomLevel} onZoom={onWaveformZoom} />
      <AudioFileUpload onUpload={onAudioFileUpload} />
    </div>
  </div>
);

ControlBar.propTypes = {
  audioProgress: T.number.isRequired,
  waveformZoomLevel: T.number.isRequired,
  isPlaying: T.bool.isRequired,
  isLoading: T.bool.isRequired,
  onPlay: T.func.isRequired,
  onPause: T.func.isRequired,
  onAddMarker: T.func.isRequired,
  onWaveformZoom: T.func.isRequired,
  onAudioFileUpload: T.func.isRequired,
};

export default ControlBar;
